export default "__VITE_ASSET__D0S4b_h7__"